/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { LoaderWrapper } from '../../../../../components';
import PurpleButton from '../../../../../componentsV2/PurpleButton';
import WhiteButton from '../../../../../componentsV2/WhiteButton';

const disConnectedComponent = ({ updateConnection, showDelete, toggleDelete, deleteLoader, connectLoader, setErrorMessage }) => {
    return (
        <>
            {
                showDelete ? (
                    <div style={{ margin: 'auto', textAlign: 'center' }}>
                        <LoaderWrapper isLoading={deleteLoader}>
                            <WhiteButton margin='10px auto' onClick={() => updateConnection('delete')}>Delete the connection</WhiteButton>
                        </LoaderWrapper>
                        <br />
                        <a href='#' className='connected-delete-btn' onClick={() => {
                            setErrorMessage('');
                            toggleDelete(false);
                        }}>Back</a>
                    </div>
                ) : (
                    <div style={{ margin: 'auto', textAlign: 'center' }}>
                        <LoaderWrapper isLoading={connectLoader}>
                            <PurpleButton margin='20px auto 10px' onClick={() => updateConnection('connect')} >Connect</PurpleButton>
                        </LoaderWrapper>
                        <p style={{ color: '#555', margin: '6px auto' }}>or</p>
                        <PurpleButton margin='10px auto' onClick={() => toggleDelete(true)} >Delete the connection</PurpleButton>
                    </div>
                )
            }
        </>
    );
}

export default disConnectedComponent;